import { Asset } from 'expo-asset';
import {
  DOWNLOAD_FILENAME,
  MINGCHUAN_QR_IMAGE,
  MINGCHUAN_WEBSITE_URL,
} from './downloadMingchuanQr.shared';

export { MINGCHUAN_WEBSITE_URL, MINGCHUAN_QR_IMAGE };

async function fetchQrBlob() {
  const asset = Asset.fromModule(MINGCHUAN_QR_IMAGE);
  await asset.downloadAsync();
  const uri = asset.localUri || asset.uri;
  if (!uri) {
    throw new Error('Could not load QR code image');
  }
  const response = await fetch(uri);
  if (!response.ok) {
    throw new Error('Could not load QR code image');
  }
  return response.blob();
}

export async function downloadMingchuanQrCode() {
  const blob = await fetchQrBlob();

  if (typeof navigator !== 'undefined' && typeof navigator.share === 'function' && typeof File !== 'undefined') {
    try {
      const file = new File([blob], DOWNLOAD_FILENAME, { type: 'image/png' });
      if (navigator.canShare?.({ files: [file] })) {
        await navigator.share({ files: [file], title: 'Ming Chuan website QR code' });
        return;
      }
    } catch (err) {
      if (err?.name === 'AbortError') return;
    }
  }

  if (typeof document === 'undefined') {
    throw new Error('Download is not supported in this environment');
  }

  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = DOWNLOAD_FILENAME;
  anchor.rel = 'noopener';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => URL.revokeObjectURL(url), 500);
}
